export const LOCALE_REQUEST_HEADER_KEY = "x-grover-language";
export const STORE_REQUEST_HEADER_KEY = "x-grover-store";
export const GRAPHQL_CLIENT_NAME = "x-graphql-client-name";
export const GRAPHQL_CLIENT_VERSION = "x-graphql-client-version";
